import isExifRotationSupported from '../verifiers/is-exif-rotation-supported';

const resetImageExifOrientation = (asset, orientation) => {
  if (isExifRotationSupported()) {
    return Promise.resolve(asset);
  }

  return new Promise((resolve) => {
    const img = new Image();
    const src = URL.createObjectURL(asset);

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const { width, height } = img;

      if (orientation > 4 && orientation < 9) {
        canvas.width = height;
        canvas.height = width;
      } else {
        canvas.width = width;
        canvas.height = height;
      }

      // https://stackoverflow.com/a/40867559
      switch (orientation) {
        case 2:
          ctx.transform(-1, 0, 0, 1, width, 0);
          break;
        case 3:
          ctx.transform(-1, 0, 0, -1, width, height);
          break;
        case 4:
          ctx.transform(1, 0, 0, -1, 0, height);
          break;
        case 5:
          ctx.transform(0, 1, 1, 0, 0, 0);
          break;
        case 6:
          ctx.transform(0, 1, -1, 0, height, 0);
          break;
        case 7:
          ctx.transform(0, -1, -1, 0, height, width);
          break;
        case 8:
          ctx.transform(0, -1, 1, 0, 0, width);
          break;
        default:
          break;
      }

      ctx.drawImage(img, 0, 0);

      canvas.toBlob((blob) => resolve(blob));
    };

    img.src = src;
  });
};

export default resetImageExifOrientation;
